import { FormModel } from "ant-design-vue"
import { computed, Ref, shallowRef } from "vue"

import i18n from "@/i18n"

export default (formRef: Ref<FormModel | null>) => {
  const isValidForm = shallowRef(false)
  const formErrors = shallowRef()

  const validateForm = async () => {
    if (!formRef?.value || typeof formRef.value.validate !== "function") {
      console.warn("Ant Form reference is invalid or missing 'validate' method.")
      return false
    }

    await formRef.value.validate((valid, errors) => {
      formErrors.value = errors && Object.keys(errors)?.length ? errors : undefined
      isValidForm.value = Boolean(valid)
    })
    return isValidForm.value
  }

  const resetFields = () => {
    if (!formRef.value || typeof formRef.value.resetFields !== "function") {
      console.warn("Ant Form reference is invalid or missing 'resetFields' method.")
      return
    }

    formRef.value.resetFields()
  }

  const formValidateRules = computed(() => ({
    textRequiredRule: [
      { whitespace: true, required: true, message: i18n.t("validations.required_field") }
    ],
    numberRequiredRule: [
      { required: true, message: i18n.t("validations.required_field"), type: "number" }
    ]
  }))

  return {
    isValidForm,
    formErrors,
    formValidateRules,
    validateForm,
    resetFields
  }
}
